import { useEffect, useState } from "react";

export function useEffectWhenChanged<T>(watchable: T, effect: (value: T) => void, deps: any[]) {
  const [value, setValue] = useState(watchable);

  useEffect(() => {
    if (value !== watchable) {
      setValue(watchable);
      effect(watchable);
    }
  }, [watchable, ...deps]);
}

export function useEffectWhenChangedOnceDefined<T>(watchable: T, effect: (value: T) => void, deps: any[]) {
  const [value, setValue] = useState(watchable);

  useEffect(() => {
    if (value !== watchable && value !== undefined && value !== null) {
      setValue(watchable);
      effect(watchable);
    } else if (value !== watchable) {
      setValue(watchable);
    }
  }, [watchable, ...deps]);
}
